import React, {useContext, useEffect, useRef, useState} from "react";
import {useMessages} from "../../hooks/useMessages";
import {getLocalStorageItem, removeLocalStorageItem} from "../../shared/localStorageUtil";
import {AddItemType} from "../../types/AddItemType";
import {ILoggedOutShoppingList} from "../../interfaces/ILoggedOutShoppingList";
import Form from "react-bootstrap/Form";
import CustomInput, {InputTypeEnum} from "../CustomInput";
import Button from "../Button";
import styled from "styled-components";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DateSelector from "../DateSelector";
import {formatSimpleDate, getMaxDate, getMinDate} from "../utils/DateUtils";
import {useMutation} from '@tanstack/react-query';
import {useCountryLang} from "../../hooks/useCountryLang";
import baseTheme from "../../shared/baseTheme";
import {useCountryList} from "../../hooks/userCountryList";
import {request} from "../../shared/httpInterceptor";
import {signIn} from "next-auth/react";
import {LoggedOutCartContext} from "../../contexts/LoggedOutCartContext";
import {LoggedOutWishlistContext} from "../../contexts/LoggedOutWishlistContext";
import useCompanyInit from "../../hooks/useCompanyInit";
import {ISelectType} from "../../interfaces/ISelectType";
import CustomSelect from "../CustomSelect";
import usePrivateRegisterInit from "../../hooks/usePrivateRegisterInit";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {useRouter} from "next/router";
import Link from "next/link";
import {Spinner} from "react-bootstrap";
import {getTheme} from "../../shared/themeUtils";
import {PASS_MIN_LENGTH} from "../../shared/constants";

const RegisterContain = styled.div`
    .register-form {
        margin-top: ${getTheme("space.3")};

        .phone-error-msg {
            color: ${getTheme("colors.textRed")};
            font-size: ${getTheme("fontSizes.small")};
            text-align: left;
        }

        .section-heading {
            font-weight: bold;
            text-align: left;
            margin-top: ${getTheme("space.3")};
            font-size: ${getTheme("fontSizes.small")};
        }

        .gender-section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: ${getTheme("space.1")};

            label.form-label {
                font-size: ${getTheme("fontSizes.small")};
                color: ${getTheme("colors.secondaryFont")};
            }

            .gender-selection {
                display: flex;

                .form-check {
                    margin-right: ${getTheme("space.2")};
                }
            }
        }

        .phone-number-label {
            font-size: ${getTheme("fontSizes.small")};
            color: ${getTheme("colors.secondaryFont")};
            text-align: left;
            margin-top: ${getTheme("space.2")};
        }

        .toggle-street-postbox {
            display: inline-block;
            width: 100%;
            text-align: left;
            font-size: ${getTheme("fontSizes.xSmall")};
            text-decoration: underline;
            color: ${getTheme("colors.secondaryFont")};
            position: relative;
            bottom: ${getTheme("space.1")};
            cursor: pointer;
        }

        .selection-group {
            position: relative;

            .select-label {
                text-align: left;
                font-size: ${getTheme("fontSizes.xSmall")};
                color: ${getTheme("colors.secondaryFont")};
                opacity: .7;
            }

            .react-select {
                width: 100%;
                text-align: left;
            }
        }

        .error-section {
            color: red;
            font-size: ${getTheme("fontSizes.small")};
            margin-top: ${getTheme("space.2")};
        }

        .check-fields-error {
            margin-top: ${getTheme("space.2")};
            color: red;
        }
    }

    .agree-terms-conditions {
        text-align: left;
        font-size: ${getTheme("fontSizes.small")};
        font-weight: 500;
        cursor: pointer;

        .terms-link {
            text-decoration: underline;
            color: ${getTheme("colors.secondaryFont")};
        }
    }

    .password-match-error {
        color: red;
        margin-bottom: ${getTheme("space.1")};
    }
`;

type RegisterPropsType = {
  registerType?: "private" | "company"
}

const Register = (props: RegisterPropsType) => {
    const router = useRouter();
    const {setLoggedOutCartCtx} = useContext(LoggedOutCartContext);
    const {setLoggedOutWishlistCtx} = useContext(LoggedOutWishlistContext);
    const companyInitQuery = useCompanyInit();
    const privateInitQuery = usePrivateRegisterInit();

    const countryLang = useCountryLang();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [loginEmail, setLoginEmail] = useState("");
    const [username, setUsername] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isPasswordMatch, setIsPasswordMatch] = useState(false);
    const [birthDate, setBirthDate] = useState(getMaxDate());
    const [gender, setGender] = useState<string | null>(null);

    const [companyName, setCompanyName] = useState("");
    const [vatId, setVatId] = useState<string | null>(null);
    const [companySize, setCompanySize] = useState<ISelectType | null>(null);
    const [companyDomain, setCompanyDomain] = useState<ISelectType | null>(null);
    const [companyLegalForm, setCompanyLegalForm] = useState<ISelectType | null>(null);
    const [companyPosition, setCompanyPosition] = useState<ISelectType | null>(null);

    const [street, setStreet] = useState("");
    const [city, setCity] = useState("");
    const [postcode, setPostcode] = useState("");
    const [digicode, setDigicode] = useState("");
  const [postbox, setPostbox] = useState<string | null>(null);
    const [countryCode, setCountryCode] = useState(router && router.query.country ? router.query.country.toString().toUpperCase() : "");
    const [mobilePhoneNumber, setMobilePhoneNumber] = useState("");
  const [mobilePhoneNumberCountry, setMobilePhoneNumberCountry] = useState(router && router.query.country ? router.query.country?.toString().toUpperCase() : "CH");
    const [faxNumber, setFaxNumber] = useState("");
    const [state, setState] = useState("");
  const [careOf, setCareOf] = useState<string | null>(null);

    const [showStreet, setShowStreet] = useState(true);

    const [countries, setCountries] = useState([] as Array<any>);
    const countryListQuery = useCountryList();

    const [errors, setErrors] = useState({} as any);
    const [generalErrors, setGeneralErrors] = useState([] as any);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const selectRef: any = useRef();

  const [activeTab, setActiveTab] = useState<any>(props.registerType ? props.registerType : "private");
    const messagesQuery = useMessages();

  const getTermsConditionsMessage = (messages: any) => {
    const parts = messages["accept-terms-and-conditions-message"].split(/(\${termsAndConditions}|\${privacyPolicy})/g);
    return parts.map((part: any, index: number) => {
      if (part === "${termsAndConditions}") {
        return (
          <Link key={index}
                className="terms-link"
                target={"_blank"}
                href={`/${countryLang}/faq/termsandconditions`}>
            {messages["terms-and-conditions"]}
          </Link>
        );
      } else if (part === "${privacyPolicy}") {
        return (
          <Link key={index}
                className="terms-link"
                target={"_blank"}
                href={`/${countryLang}/faq/privacystatement`}>
            {messages["policy-configurator-all.privacy-policy"]}
          </Link>
        );
      }
      return part;
    });
  };

    useEffect(() => {
        if (countryListQuery.data) {
            const countryKeys = Object.keys(countryListQuery.data);
            const countryArray: Array<any> = [];
            countryKeys.forEach(k => {
                countryArray.push({
                    value: k,
                    label: countryListQuery.data[k]
                });
            });

            setCountries(countryArray);
        }
    }, [countryListQuery.data]);

    const toggleStreetPostbox = () => {
        setStreet("");
        setPostbox("");
        setShowStreet(!showStreet);
    };

    const handlePasswordChange = (newPassword: string) => {
        setLoginPassword(newPassword);
        setIsPasswordMatch(newPassword === confirmPassword);
    };

    const handleConfirmPasswordChange = (newConfirmPassword: string) => {
        setConfirmPassword(newConfirmPassword);
        setIsPasswordMatch(loginPassword === newConfirmPassword);
    };

    const registerPersonalMutation = useMutation(async () => {
        setIsSubmitting(true);
        setGeneralErrors([]);
      setErrors([])
        const body = {
            data: {
                account: {
                    loginEmail,
                    loginPassword,
                    confirmPassword,
                    agreeTermsAndConditions: true,
                    newsletterMode: "N",
                    username
                },
                person: {
                    firstName,
                    lastName,
                    gender,
                    birthDate: formatSimpleDate(birthDate),
                    mobilePhoneNumber,
                    mobilePhoneNumberCountry
                },
                address: {
                    street,
                    postbox,
                    postcode,
                    city,
                    countryCode,
                    digicode,
                    careOf,
                }
            }
        };

        try {
            const res = await request({url: `/${countryLang}/register/private`, data: body, method: 'post'});

            if (res.data.accessToken) {
                await loginUser();
            }

            // fields errors
            if (res.data.fieldErrors) {
                setErrors(res.data.fieldErrors);
            }

            // general errors
            if (res.data.errors) {
                setGeneralErrors(res.data.errors);
            }

            // we check if passwords are matching
            if (loginPassword !== confirmPassword) {
                setErrors({
                    ...errors,
                    confirmPassword: [messagesQuery.data.messages["error-passwords-do-not-match"]]
                });
            }
        } catch (e) {
            console.log(e);
        }
        setIsSubmitting(false);
    });

    const registerCompanyMutation = useMutation(async () => {
        setIsSubmitting(true);
        setGeneralErrors([]);
      setErrors([])
        const body = {
            data: {
                account: {
                    loginEmail,
                    loginPassword,
                    confirmPassword,
                    agreeTermsAndConditions: true,
                    newsletterMode: "N",
                    username
                },
                person: {
                    firstName,
                    lastName,
                    companyPosition: companyPosition?.value,
                    gender,
                    birthDate: formatSimpleDate(birthDate),
                    mobilePhoneNumber,
                    mobilePhoneNumberCountry
                },
                company: {
                    companyName,
                    vatId,
                    companyLegalForm: companyLegalForm?.value,
                    companySize: companySize?.value,
                    companyLineOfBusiness: companyDomain?.value
                },
                address: {
                    addressId: null,
                    street,
                    postbox,
                    postcode,
                    city,
                    countryCode,
                    digicode,
                    faxNumber: null,
                    careOf,
                    state
                }
            }
        };

        try {
            const res = await request({url: `/${countryLang}/register/company`, data: body, method: 'post'});

            if (res.data.accessToken) {
                await loginUser();
            }

            // fields errors
            if (res.data.fieldErrors) {
                setErrors(res.data.fieldErrors);
                setVatId(null);
            }

            // general errors
            if (res.data.errors) {
                setGeneralErrors(res.data.errors);
            }

            // we check if passwords are matching
            if (loginPassword !== confirmPassword) {
                setErrors({
                    ...errors,
                    confirmPassword: [messagesQuery.data.messages["error-passwords-do-not-match"]]
                });
            }
        } catch (e) {
            console.log(e);
        }
        setIsSubmitting(false);
    });

    const loginUser = async () => {
        const loggedOutCart = getLocalStorageItem("loggedOutCart");
        let loggedOutCartItems: AddItemType[] = [];
        if (loggedOutCart != null) {
            JSON.parse(loggedOutCart).map((item: ILoggedOutShoppingList) => {
                const transformed = {
                    productId: item.product.productID,
                    quantity: item.quantity
                };
                loggedOutCartItems.push(transformed);
            });
        }

        const loggedOutCartItemsString = JSON.stringify(loggedOutCartItems);

        // Fetch logged out wishlist from local storage, transform it and pass it to login body
        const loggedOutWishlist = getLocalStorageItem("loggedOutWishlist");
        const loggedOutWishlistItems: AddItemType[] = [];
        if (loggedOutWishlist != null) {
            JSON.parse(loggedOutWishlist).map((item: ILoggedOutShoppingList) => {
                const transformed = {
                    productId: item.product.productID,
                    quantity: item.quantity
                };
                loggedOutWishlistItems.push(transformed);
            });
        }
        const loggedOutWishlistItemsString = JSON.stringify(loggedOutWishlistItems);

        await signIn("credentials-login", {
            username: loginEmail,
            password: loginPassword,
            loggedOutCartItemsString,
            loggedOutWishlistItemsString,
            redirect: false
        }).then((res: any) => {
            if (res.ok) {
                removeLocalStorageItem("loggedOutCart");
                removeLocalStorageItem("loggedOutWishlist");
                setLoggedOutCartCtx(null);
                setLoggedOutWishlistCtx(null);
            }
        });
    };

    const handlePrivateRegister = () => {
        registerPersonalMutation.mutate();
    };

    const handleCompanyRegister = () => {
        registerCompanyMutation.mutate();
    };

    const checkUserTitle = (gen: "m" | "f") => {
        return gen === gender;
    };

    const getCountry = () => {
        return countries.find(c => c.value === countryCode);
    };

    const selectStyles = {
        control: (styles: any) => ({
            ...styles,
            minHeight: "55px",
            borderColor: baseTheme.colors.border,
            borderTopLeftRadius: "0px",
            borderBottomLeftRadius: "0px",
            boxShadow: "none",
            "&:hover": {
                borderColor: baseTheme.colors.border,
            },
            outline: "none"
        })
    };


  const handleCountryChange = (value: any, country: any) => {
    setMobilePhoneNumberCountry(country.countryCode.toUpperCase());
  };

  const handleLocalNumberChange = (event: any) => {
    setMobilePhoneNumber(event.target.value);
  };

  const phoneSection = (messages: any) => (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <PhoneInput
        country={countryLang != null ? countryLang.substring(0, 2) : 'ch'}
        value={countryCode}
        onChange={handleCountryChange}
        disableDropdown={false} // Show dropdown to select country
        onlyCountries={[]} // Allows selection of any country
        inputProps={{
          style: {
            width: 'auto',
            marginRight: '10px',
            textAlign: 'center',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
          },
        }}
      />
      <input
        type="text"
        value={mobilePhoneNumber}
        placeholder={messages["phone-number"]}
        onChange={handleLocalNumberChange}
        style={{
          flex: 1,
          padding: '10px',
          border: '1px solid #ccc',
          borderLeft: "none",
          marginTop: "4px",
          borderRadius: '4px',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          height: "50px",
          outline: "none",
          borderColor: errors["mobilePhoneNumber"] != null ? "red" : "#ccc"
        }}
      />
    </div>
  )


  return (
    <RegisterContain>
      {messagesQuery.data && <span className="fs-2 fw-bold">
        {messagesQuery.data.messages["register"]}
      </span>}

      <Tabs
        id="register-type"
        activeKey={activeTab}
        onSelect={k => k != null ? setActiveTab(k) : null}
        unmountOnExit={true}
        className="flat-tabs mt-3">

        {/* Private registration */}
        {messagesQuery.data &&
          <Tab eventKey="private" title={messagesQuery.data.messages["personal"]}>
            <Form className="register-form">

              {/*PERSONAL DETAILS*/}
              <div className="section-heading">{messagesQuery.data.messages["personal-details"]}</div>

              {privateInitQuery.data && privateInitQuery.data.gender &&
                <div className="gender-section">
                  <Form.Label>{messagesQuery.data.messages["gender"]}</Form.Label>
                  {messagesQuery.data && <div className="gender-selection">
                    <Form.Check id="title-m" checked={checkUserTitle("m")}
                                onChange={(event) => setGender(event.target.value)} value={"m"}
                                type="radio"
                                name="user-title" label={messagesQuery.data.messages["mister"]}/>
                    <Form.Check id="title-f" checked={checkUserTitle("f")}
                                onChange={(event) => setGender(event.target.value)} value={"f"}
                                type="radio"
                                name="user-title" label={messagesQuery.data.messages["miss"]}/>
                  </div>}
                </div>
              }

              {privateInitQuery.data && privateInitQuery.data.firstName &&
                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["firstname"]}
                                             id={"firstName"}
                                             placeholder={messagesQuery.data.messages["firstname"]}
                                             required={!!privateInitQuery.data.firstName.required}
                                             optional={!(privateInitQuery.data.firstName.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["firstName"]}
                                             value={firstName}
                                             setValue={(value: string) => setFirstName(value)}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.lastName &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["lastname"]}
                                             id={"lastName"}
                                             placeholder={messagesQuery.data.messages["lastname"]}
                                             required={!!privateInitQuery.data.lastName.required}
                                             optional={!(privateInitQuery.data.lastName.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["lastName"]}
                                             value={lastName}
                                             setValue={(value: string) => setLastName(value)}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.birthDate &&
                                <DateSelector label={messagesQuery.data.messages["birthdate"]}
                                              errorMsg={errors["birthDate"]}
                                              required={!!privateInitQuery.data.birthDate.required}
                                              selected={birthDate} setSelected={setBirthDate}
                                              maxDate={getMaxDate()}
                                              minDate={getMinDate()}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.mobilePhoneNumber &&
                              <>
                                <div className={"phone-number-label"}>
                                  {messagesQuery.data.messages["phone-number"]}
                                </div>
                                {phoneSection(messagesQuery.data.messages)}
                                {errors["mobilePhoneNumber"] &&
                                  <div className={"phone-error-msg"}>{errors["mobilePhoneNumber"]}</div>}
                              </>
                            }

              {/* ADDRESS */}
              <div className="section-heading">{messagesQuery.data.messages["address"]}</div>

              {privateInitQuery.data && privateInitQuery.data.street && showStreet &&
                <>
                  <CustomInput type={InputTypeEnum.TEXT}
                               label={messagesQuery.data.messages["street-nr"]}
                               id={"street"}
                               placeholder={messagesQuery.data.messages["street-nr"]}
                               errorMsg={errors["street"]}
                               required={!!privateInitQuery.data.street.required}
                               optional={!(privateInitQuery.data.street.required)}
                                                 optionalText={messagesQuery.data.messages["optional"]}
                                                 value={street}
                                                 setValue={(value: string) => setStreet(value)}/>
                                    {privateInitQuery.data.postbox && <span className="toggle-street-postbox"
                                                                            onClick={toggleStreetPostbox}>{messagesQuery.data.messages["add-postbox"]}</span>}
                                </>
                            }

                            {privateInitQuery.data && privateInitQuery.data.postbox && !showStreet &&
                                <>
                                    <CustomInput type={InputTypeEnum.TEXT}
                                                 label={messagesQuery.data.messages["postbox"]}
                                                 id={"postbox"}
                                                 placeholder={messagesQuery.data.messages["postbox"]}
                                                 errorMsg={errors["postbox"]}
                                                 required={!!privateInitQuery.data.postbox.required}
                                                 optional={!(privateInitQuery.data.postbox.required)}
                                                 optionalText={messagesQuery.data.messages["optional"]}
                                                 value={postbox ? postbox : ""}
                                                 setValue={(value: string) => setPostbox(value)}/>
                                    {privateInitQuery.data.street && <span className="toggle-street-postbox"
                                                                           onClick={toggleStreetPostbox}>{messagesQuery.data.messages["add-street"]}</span>}
                                </>
                            }

                            {privateInitQuery.data && privateInitQuery.data.careOf &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["co"]}
                                             id={"careOf"}
                                             placeholder={messagesQuery.data.messages["co"]}
                                             optional={!(privateInitQuery.data.careOf.required)}
                                             required={!!privateInitQuery.data.careOf.required}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["co"]}
                                             value={careOf ? careOf : ""}
                                             setValue={(value: string) => setCareOf(value)}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.postcode &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["postcode"]}
                                             id={"postcode"}
                                             placeholder={messagesQuery.data.messages["postcode"]}
                                             optional={!(privateInitQuery.data.postcode.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["postcode"]}
                                             required={!!privateInitQuery.data.postcode.required}
                                             value={postcode}
                                             setValue={(value: string) => setPostcode(value)}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.city &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["city"]}
                                             id={"city"}
                                             placeholder={messagesQuery.data.messages["city"]}
                                             optional={!(privateInitQuery.data.city.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["city"]}
                                             required={!!privateInitQuery.data.city.required}
                                             value={city}
                                             setValue={(value: string) => setCity(value)}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.countryCode &&
                                <CustomSelect id={"countryCode"}
                                              label={messagesQuery.data.messages["country"]}
                                              options={countries}
                                              value={getCountry()}
                                              setValueFn={(event: any) => setCountryCode(event.value)}
                                              selectRef={selectRef}
                                              errorMsg={errors["countryCode"]}/>
                            }
                            {privateInitQuery.data && privateInitQuery.data.digicode &&
                              <CustomInput type={InputTypeEnum.TEXT}
                                           label={messagesQuery.data.messages["digicode"]}
                                           id={"digicode"}
                                           placeholder={messagesQuery.data.messages["digicode"]}
                                           optional={!(privateInitQuery.data.digicode.required)}
                                           optionalText={messagesQuery.data.messages["optional"]}
                                           errorMsg={errors["digicode"]}
                                           required={!!privateInitQuery.data.digicode.required}
                                           value={digicode}
                                           maxLength={10}
                                           tooltipContent={messagesQuery.data.messages["digicode.tooltip-text"]}
                                           setValue={(value: string) => setDigicode(value)}/>
                            }
                            {/* ACCOUNT DETAILS */}
                            <div className="section-heading">{messagesQuery.data.messages["account"]}</div>

                            {privateInitQuery.data && privateInitQuery.data.loginEmail &&
                                <CustomInput type={InputTypeEnum.EMAIL}
                                             label={messagesQuery.data.messages["email-address"]}
                                             id={"loginEmail"}
                                             placeholder={messagesQuery.data.messages["email-address"]}
                                             errorMsg={errors["loginEmail"]}
                                             required={!!privateInitQuery.data.loginEmail.required}
                                             optional={!(privateInitQuery.data.loginEmail.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             value={loginEmail}
                                             setValue={(value: string) => setLoginEmail(value)}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.loginPassword &&
                                <CustomInput type={InputTypeEnum.PASSWORD}
                                             label={messagesQuery.data.messages["password"]}
                                             id={"loginPassword"}
                                             placeholder={messagesQuery.data.messages["password"]}
                                             errorMsg={errors["loginPassword"]}
                                             required={!!privateInitQuery.data.loginPassword.required}
                                             optional={!(privateInitQuery.data.loginPassword.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             minLength={PASS_MIN_LENGTH}
                                             value={loginPassword}
                                             setValue={(value: string) => handlePasswordChange(value)}/>
                            }

                            {privateInitQuery.data && privateInitQuery.data.confirmPassword &&
                                <CustomInput type={InputTypeEnum.PASSWORD}
                                             label={messagesQuery.data.messages["confirm-password"]}
                                             id={"confirmPassword"}
                                             className={!isPasswordMatch && confirmPassword ? "border border-danger rounded" : ""}
                                             placeholder={messagesQuery.data.messages["confirm-password"]}
                                             errorMsg={errors["confirmPassword"]}
                                             required={!!privateInitQuery.data.confirmPassword.required}
                                             optional={!(privateInitQuery.data.confirmPassword.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             minLength={PASS_MIN_LENGTH}
                                             value={confirmPassword}
                                             setValue={(value: string) => handleConfirmPasswordChange(value)}/>
                            }

                            {!isPasswordMatch && confirmPassword && (
                                <span
                                    className={"password-match-error"}>{messagesQuery.data.messages["error-passwords-do-not-match"]}</span>
                            )}

                            {privateInitQuery.data && privateInitQuery.data.username &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["community-username"]}
                                             id={"communityName"}
                                             placeholder={messagesQuery.data.messages["community-username"]}
                                             errorMsg={errors["username"]}
                                             required={!!privateInitQuery.data.username.required}
                                             optional={!(privateInitQuery.data.username.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             value={username}
                                             setValue={(value: string) => setUsername(value)}/>
                            }

                          {messagesQuery.data && messagesQuery.data.messages["accept-terms-and-conditions-message"] != null &&
                            <div className="agree-terms-conditions">
                              {getTermsConditionsMessage(messagesQuery.data.messages)}
                            </div>
                          }

                            {generalErrors &&
                                <div className="error-section">
                                    {generalErrors.map((err: string) => {
                                        return (
                                            <p key={err}>{err}</p>
                                        );
                                    })}
                                </div>
                            }

                            {Object.keys(errors).length > 0 &&
                                <div className="check-fields-error">
                                    {messagesQuery.data && messagesQuery.data.messages["check-errors-above"]}
                                </div>
                            }

                            {!isSubmitting &&
                                <Button variant="primary" onClick={() => handlePrivateRegister()} width="100%"
                                        className="mt-3">
                                    {messagesQuery.data.messages["submit"]}
                                </Button>
                            }

                            {isSubmitting &&
                                <Button variant="primary" width="100%" className="mt-3" disabled={true}>
                                    <Spinner animation="border" size="sm"/>
                                </Button>
                            }
                        </Form>
                    </Tab>
                }

                {/* Company registration */}
                {messagesQuery.data &&
                    <Tab eventKey="company" title={messagesQuery.data.messages["company"]}>
                        <Form className="register-form">

                            {/* COMPANY DETAILS */}
                            <div className="section-heading">{messagesQuery.data.messages["company-details"]}</div>

                            {companyInitQuery.data && companyInitQuery.data.companyName &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["company"]}
                                             id={"companyName"}
                                             placeholder={messagesQuery.data.messages["company"]}
                                             errorMsg={errors["companyName"]}
                                             required={!!companyInitQuery.data.companyName.required}
                                             optional={!(companyInitQuery.data.companyName.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             maxLength={50}
                                             value={companyName}
                                             setValue={(value: string) => setCompanyName(value)}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.vatId &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["vat-number"]}
                                             id={"vatId"}
                                             placeholder={messagesQuery.data.messages["vat-number"]}
                                             required={!!companyInitQuery.data.vatId.required}
                                             optional={!(companyInitQuery.data.vatId.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["vatId"]}
                                             value={vatId != null ? vatId : ""}
                                             setValue={(value: string) => setVatId(value)}/>
                            }

                            {(companyInitQuery.data && companyInitQuery.data.companySizes) &&
                                <CustomSelect id={"companySizes"}
                                              label={messagesQuery.data.messages["company-size"]}
                                              options={companyInitQuery.data.companySizes}
                                              value={companySize}
                                              setValueFn={(selection: any) => setCompanySize(selection)}
                                              selectRef={selectRef}
                                              errorMsg={errors["companySize"]}/>
                            }

                            {(companyInitQuery.data && companyInitQuery.data.companyBusinessLines) &&
                                <CustomSelect id={"companyDomain"}
                                              label={messagesQuery.data.messages["company-domain"]}
                                              options={companyInitQuery.data.companyBusinessLines}
                                              value={companyDomain}
                                              setValueFn={(selection: any) => setCompanyDomain(selection)}
                                              selectRef={selectRef}
                                              errorMsg={errors["companyLineOfBusiness"]}/>
                            }

                            {(companyInitQuery.data && companyInitQuery.data.companyLegalForms) &&
                                <CustomSelect id={"companyLegalForms"}
                                              label={messagesQuery.data.messages["company-legal-form"]}
                                              options={companyInitQuery.data.companyLegalForms}
                                              value={companyLegalForm}
                                              setValueFn={(selection: any) => setCompanyLegalForm(selection)}
                                              selectRef={selectRef}
                                              errorMsg={errors["companyLegalForm"]}/>
                            }

                            {(companyInitQuery.data && companyInitQuery.data.companyPositions) &&
                                <CustomSelect id={"companyPosition"}
                                              label={messagesQuery.data.messages["company-position"]}
                                              options={companyInitQuery.data.companyPositions}
                                              value={companyPosition}
                                              setValueFn={(selection: any) => setCompanyPosition(selection)}
                                              selectRef={selectRef}
                                              errorMsg={errors["companyPosition"]}/>
                            }

                            {/*PERSONAL DETAILS*/}
                            <div className="section-heading">{messagesQuery.data.messages["personal-details"]}</div>

                            {companyInitQuery.data && companyInitQuery.data.gender &&
                                <div className="gender-section">
                                    <Form.Label>{messagesQuery.data.messages["gender"]}</Form.Label>
                                    {messagesQuery.data && <div className="gender-selection">
                                        <Form.Check id="title-m" checked={checkUserTitle("m")}
                                                    onChange={(event) => setGender(event.target.value)} value={"m"}
                                                    type="radio"
                                                    name="user-title" label={messagesQuery.data.messages["mister"]}/>
                                        <Form.Check id="title-f" checked={checkUserTitle("f")}
                                                    onChange={(event) => setGender(event.target.value)} value={"f"}
                                                    type="radio"
                                                    name="user-title" label={messagesQuery.data.messages["miss"]}/>
                                    </div>}
                                </div>
                            }

                            {companyInitQuery.data && companyInitQuery.data.firstName &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["firstname"]}
                                             id={"firstName"}
                                             placeholder={messagesQuery.data.messages["firstname"]}
                                             errorMsg={errors["firstName"]}
                                             required={!!companyInitQuery.data.firstName.required}
                                             optional={!(companyInitQuery.data.firstName.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             value={firstName}
                                             setValue={(value: string) => setFirstName(value)}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.lastName &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["lastname"]}
                                             id={"lastName"}
                                             placeholder={messagesQuery.data.messages["lastname"]}
                                             errorMsg={errors["lastName"]}
                                             required={!!companyInitQuery.data.lastName.required}
                                             optional={!(companyInitQuery.data.lastName.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             value={lastName}
                                             setValue={(value: string) => setLastName(value)}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.birthDate &&
                                <DateSelector label={messagesQuery.data.messages["birthdate"]}
                                              errorMsg={errors["birthDate"]}
                                              selected={birthDate}
                                              required={!!companyInitQuery.data.birthDate.required}
                                              setSelected={setBirthDate}
                                              maxDate={getMaxDate()}
                                              minDate={getMinDate()}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.mobilePhoneNumber &&
                                <>
                                    <div className={"phone-number-label"}>
                                        {messagesQuery.data.messages["phone-number"]}
                                    </div>
                                  {phoneSection(messagesQuery.data.messages)}
                                    {errors["mobilePhoneNumber"] &&
                                        <div className={"phone-error-msg"}>{errors["mobilePhoneNumber"]}</div>}
                                </>
                            }

                            {/* ADDRESS */}
                            <div className="section-heading">{messagesQuery.data.messages["address"]}</div>

                            {companyInitQuery.data && companyInitQuery.data.street && showStreet &&
                                <>
                                    <CustomInput type={InputTypeEnum.TEXT}
                                                 label={messagesQuery.data.messages["street-nr"]}
                                                 id={"street"}
                                                 placeholder={messagesQuery.data.messages["street-nr"]}
                                                 required={!!companyInitQuery.data.street.required}
                                                 optional={!(companyInitQuery.data.street.required)}
                                                 optionalText={messagesQuery.data.messages["optional"]}
                                                 errorMsg={errors["street"]}
                                                 value={street}
                                                 setValue={(value: string) => setStreet(value)}/>
                                    {companyInitQuery.data.postbox && <span className="toggle-street-postbox"
                                                                            onClick={toggleStreetPostbox}>{messagesQuery.data.messages["add-postbox"]}</span>}
                                </>
                            }

                            {companyInitQuery.data && companyInitQuery.data.postbox && !showStreet &&
                                <>
                                    <CustomInput type={InputTypeEnum.TEXT}
                                                 label={messagesQuery.data.messages["postbox"]}
                                                 id={"postbox"}
                                                 placeholder={messagesQuery.data.messages["postbox"]}
                                                 required={!!companyInitQuery.data.postbox.required}
                                                 optional={!(companyInitQuery.data.postbox.required)}
                                                 optionalText={messagesQuery.data.messages["optional"]}
                                                 errorMsg={errors["postbox"]}
                                                 value={postbox ? postbox : ""}
                                                 setValue={(value: string) => setPostbox(value)}/>
                                    {companyInitQuery.data.street && <span className="toggle-street-postbox"
                                                                           onClick={toggleStreetPostbox}>{messagesQuery.data.messages["add-street"]}</span>}
                                </>
                            }

                            {companyInitQuery.data && companyInitQuery.data.postcode &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["postcode"]}
                                             id={"postcode"}
                                             placeholder={messagesQuery.data.messages["postcode"]}
                                             required={!!companyInitQuery.data.postcode.required}
                                             optional={!(companyInitQuery.data.postcode.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["postcode"]}
                                             value={postcode}
                                             setValue={(value: string) => setPostcode(value)}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.city &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["city"]}
                                             id={"city"}
                                             placeholder={messagesQuery.data.messages["city"]}
                                             required={!!companyInitQuery.data.city.required}
                                             optional={!(companyInitQuery.data.city.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["city"]}
                                             value={city}
                                             setValue={(value: string) => setCity(value)}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.countryCode &&
                                <CustomSelect id={"countryCode"}
                                              label={messagesQuery.data.messages["country"]}
                                              options={countries}
                                              value={getCountry()}
                                              setValueFn={(event: any) => setCountryCode(event.value)}
                                              selectRef={selectRef}
                                              errorMsg={errors["countryCode"]}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.digicode &&
                              <CustomInput type={InputTypeEnum.TEXT}
                                           label={messagesQuery.data.messages["digicode"]}
                                           id={"digicode"}
                                           placeholder={messagesQuery.data.messages["digicode"]}
                                           optional={!(companyInitQuery.data.digicode.required)}
                                           optionalText={messagesQuery.data.messages["optional"]}
                                           errorMsg={errors["digicode"]}
                                           required={!!companyInitQuery.data.digicode.required}
                                           value={digicode}
                                           maxLength={10}
                                           tooltipContent={messagesQuery.data.messages["digicode.tooltip-text"]}
                                           setValue={(value: string) => setDigicode(value)}/>
                            }

                            {/* ACCOUNT DETAILS */}
                            <div className="section-heading">{messagesQuery.data.messages["account"]}</div>

                            {companyInitQuery.data && companyInitQuery.data.loginEmail &&
                                <CustomInput type={InputTypeEnum.EMAIL}
                                             label={messagesQuery.data.messages["email-address"]}
                                             id={"loginEmail"}
                                             placeholder={messagesQuery.data.messages["email-address"]}
                                             required={!!companyInitQuery.data.loginEmail.required}
                                             optional={!(companyInitQuery.data.loginEmail.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["loginEmail"]}
                                             value={loginEmail}
                                             setValue={(value: string) => setLoginEmail(value)}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.loginPassword &&
                                <CustomInput type={InputTypeEnum.PASSWORD}
                                             label={messagesQuery.data.messages["password"]}
                                             id={"loginPassword"}
                                             placeholder={messagesQuery.data.messages["password"]}
                                             required={!!companyInitQuery.data.loginPassword.required}
                                             optional={!(companyInitQuery.data.loginPassword.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["loginPassword"]}
                                             minLength={PASS_MIN_LENGTH}
                                             value={loginPassword}
                                             setValue={(value: string) => handlePasswordChange(value)}/>
                            }

                            {companyInitQuery.data && companyInitQuery.data.confirmPassword &&
                                <CustomInput type={InputTypeEnum.PASSWORD}
                                             label={messagesQuery.data.messages["confirm-password"]}
                                             id={"confirmPassword"}
                                             className={!isPasswordMatch && confirmPassword ? "border border-danger rounded" : ""}
                                             placeholder={messagesQuery.data.messages["confirm-password"]}
                                             required={!!companyInitQuery.data.confirmPassword.required}
                                             optional={!(companyInitQuery.data.confirmPassword.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             errorMsg={errors["confirmPassword"]}
                                             minLength={PASS_MIN_LENGTH}
                                             value={confirmPassword}
                                             setValue={(value: string) => handleConfirmPasswordChange(value)}/>
                            }

                            {!isPasswordMatch && confirmPassword && (
                                <span
                                    className={"password-match-error"}>{messagesQuery.data.messages["error-passwords-do-not-match"]}</span>
                            )}

                            {companyInitQuery.data && companyInitQuery.data.username &&
                                <CustomInput type={InputTypeEnum.TEXT}
                                             label={messagesQuery.data.messages["community-username"]}
                                             id={"communityName"}
                                             placeholder={messagesQuery.data.messages["community-username"]}
                                             errorMsg={errors["username"]}
                                             required={!!companyInitQuery.data.username.required}
                                             optional={!(companyInitQuery.data.username.required)}
                                             optionalText={messagesQuery.data.messages["optional"]}
                                             value={username}
                                             setValue={(value: string) => setUsername(value)}/>
                            }

                          {messagesQuery.data && messagesQuery.data.messages["accept-terms-and-conditions-message"] != null &&
                            <div className="agree-terms-conditions">
                              {getTermsConditionsMessage(messagesQuery.data.messages)}
                            </div>
                          }

                            {Object.keys(errors).length > 0 &&
                                <div className="check-fields-error">
                                    {messagesQuery.data && messagesQuery.data.messages["check-errors-above"]}
                                </div>
                            }

                            {!isSubmitting &&
                                <Button variant="primary" onClick={() => handleCompanyRegister()} width="100%"
                                        className="mt-3">
                                    {messagesQuery.data.messages["submit"]}
                                </Button>
                            }

                            {isSubmitting &&
                                <Button variant="primary" width="100%" className="mt-3" disabled={true}>
                                    <Spinner animation="border" size="sm"/>
                                </Button>
                            }
                        </Form>
                    </Tab>
                }
            </Tabs>
        </RegisterContain>
    );
};

export default Register;
